var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{'show': _vm.shown}},[_c('img',{staticClass:"imgMed container",style:({'width': _vm.thisWidth}),attrs:{"src":_vm.url,"alt":_vm.media.alt}})])}
var staticRenderFns = []

export { render, staticRenderFns }